export class GridSetting {
    sorting: boolean = true;
    datePicker: boolean = true;
    charting: boolean = true;
    deratingFactor: boolean = true;
    expansion: boolean = true;
    contextMenu: boolean = true;
    message: boolean = true;
    sendSaveChangesMessage: boolean = true;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/grid-setting.ts